<template>
  <div>
    <div class="page-integrations__description has-text-centered">
      {{ app.subtitle }}
    </div>
    <div class="buttons">
      <sc-tooltip 
        class="tooltip"
        :label="app.status === 'MANUALLY_INSTALLED' ? 
        'Você já possui essa transportadora instalada! Veja em Minhas Transportadoras' : ''"
        multilined>
        <sc-button
          v-if="['UNINSTALLED', 'INSTALL_FAILED'].includes(app.status)"
          :id="`install-btn-${app.id}`"
          class="is-fullwidth"
          theme="primary"
          text="Instalar"
          :disabled="loading"
          @click="() => handleStepClick(app)"
        />

        <sc-button
          v-else
          :id="`installed-btn-${app.id}`"
          class="is-fullwidth"
          theme="success"
          icon="check-circle"
          text="Instalado"
        />
      </sc-tooltip>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScButton, ScDialog, ScToast, ScTooltip } from '@intelipost-js/secure-components';

const { mapState } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);
export default {
  name: 'integrations-self-service-card-body',

  props: {
    app: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(['loading']),
  },
  methods: {
    handleStepClick(app) {
      this.$router.push({ name: 'integrations-app-self-service', params: { id: app.id } });
    },
  },

  components: {
    ScButton,
    ScDialog,
    ScToast,
    ScTooltip,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {
  .sc-card {
    .card-image {
      .image {
        padding-top: 60%;
      }
    }

    .card-menu-button {
      border: none;
      background-color: white;
      margin: 1rem 0 0 0;
    }

    .report-problem-form {
      display: flex;
      margin-bottom: 2rem;

      .report-problem-button {
        margin-top: 2rem;
      }
    }

    img {
      object-fit: scale-down;
      width: 80%;
      margin: auto;
    }
    .tooltip {
      width: 100%;
    }
    .is-warning {
      background-color: #ffe683;
      border-color: #ffdd57;
    }
  }
}

</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/app-list/app-card/body-card/BodyCard.vue